import { Component, Input } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { MatIcon } from '@angular/material/icon';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
import { RouterLinkActive, RouterLink } from '@angular/router';

@Component({
    selector: 'app-consult-note-title',
    templateUrl: './consult-note-title.component.html',
    styleUrls: ['./consult-note-title.component.scss'],
    imports: [MatIcon, UserPresenceComponent, RouterLinkActive, RouterLink]
})
export class ConsultNoteTitleComponent {
  @Input() patientAttachment: PatientAttachment;

  constructor() {}
}
